import React, { useState, Fragment } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import classes from "../../assets/css/HeaderDropdown.module.scss";
import headerDropdownService from "../../services/headerDropdown.service";
import { useTranslation } from "react-i18next";

const UserTypeDropdown = (props: any) => {
  const { t, i18n } = useTranslation(["Header", "Common"]);
  const [selectedUserType, setUserType] = useState(0);

  const onUserTypeChange = (event: any) => {
    setUserType(event.target.value);
    const dropdownData = {
      type: "teamList",
      data: { userType: event.target.value },
    };
    headerDropdownService.emit(dropdownData);
  };
  const userTypeList = [
    { label: t("Header:All User Types"), value: 0 },
    { label: t("Common:Supervisor"), value: 2 },
    { label: t("Common:Agents"), value: 1 },
  ];
  const renderTeamList = () => {
    return (
      userTypeList.length > 0 &&
      userTypeList.map((team: any, index: any) => {
        return <MenuItem value={team.value}> {team.label}</MenuItem>;
      })
    );
  };
  return (
    <Fragment>
      {/* <img
        src={TeamDropdownIcon}
        alt="team drpdown"
        className={classes["dropdown-pre-icon"]}
      ></img> */}
      <div className={classes["dropdownOuter"]}>
        <Select
          MenuProps={{
            disableScrollLock: true,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          disableUnderline={true}
          value={selectedUserType}
          onChange={onUserTypeChange}
        >
          {renderTeamList()}
        </Select>
      </div>
    </Fragment>
  );
};
export default UserTypeDropdown;
